import { Center, Image } from '@chakra-ui/react'
import { t } from '@lingui/macro'
import { ButtonIcon, ButtonIconPropType } from 'front-end/src/components'
import React, { useState } from 'react'
import { rgba } from 'shared/colorUtils'
import { useLooopTheme } from '../../public-api/hooks/useLooopTheme'
import IconEyeCrossed from './icon-eye-crossed.svg'
import IconEye from './icon-eye.svg'

export const useInputMaskingToggle = (props?: {
  buttonProps: Partial<ButtonIconPropType>
}) => {
  const { theme } = useLooopTheme()
  const [isUnmasked, setUnmasked] = useState(false)
  const eyeButtonLabel = isUnmasked ? t`Hide password` : t`Show password`

  return {
    isUnmasked,
    eyeButton: (
      <ButtonIcon
        onClick={() => {
          setUnmasked(!isUnmasked)
        }}
        boxSize="32px"
        maxH="32px"
        borderRadius="50%"
        minW="unset"
        backgroundColor={
          isUnmasked
            ? `rgba(${rgba(theme.colors.buttonPrimary.default, 0.2)})`
            : 'initial'
        }
        aria-label={eyeButtonLabel}
        aria-pressed={isUnmasked}
        hint={eyeButtonLabel}
        {...props?.buttonProps}
      >
        <Center>
          <Image src={isUnmasked ? IconEyeCrossed : IconEye} boxSize="20px" />
        </Center>
      </ButtonIcon>
    )
  }
}
